const SideBarItem = ({ active, name }) => {
  return (
    <div className={`sidebar__item ${active ? "active" : ""}`}> {name} </div>
  );
};

export default SideBarItem;
